import apiFactory from "./factory";
import {IS_DEV_ENV} from "../utils";
import {useEffect, useState} from "react";
import { showToast } from "../Utilities";

export default function useSubscriptionApi ()
{
    const {call, ...factory} = apiFactory();

    const fetchSeatsInformation = () => {
        return call({
            actions: {
                response: {
                    "Subscription\\Subscription": {
                        custom: {
                            functionName: "getSeatsInformation",
                            get: "result",
                            criteria: {},
                        }
                    }
                }
            }
        }).then((response) => {
            if (response?.status !== 200) {
                showToast({
                    type: 'Error',
                    title: 'We are sorry 😥.',
                    content: `Something went wrong. Please try again`,
                });
                return;
            } else {
                return response?.data?.data?.result
            }
        })
    }

    const fetchSubscriptions = () => {
        return call({
            actions: {
                response: {
                    "Subscription\\Subscription": {
                        custom: {
                            functionName: "getLegacySubscriptions",
                            get: "subscriptions",
                            criteria: {},
                            includes: {
                                0: "id",
                                1: "processorId",
                                2: "interval",
                                3: "status",
                                4: "data",
                                5: "type",
                                6: "tier",
                                "subscriptionItems": {
                                    0: "id",
                                    1: "processorId",
                                    2: "status",
                                    3: "processorPriceId",
                                    4: "processorPriceData",
                                    5: "name",
                                    "product": {
                                        0: "id",
                                        1: "name",
                                        2: "type",
                                        3: "tier",
                                        4: "interval",
                                        5: "name",
                                        6: "features",
                                        7: "chargeAfterEvent",
                                        8: "description",
                                        9: "processorData",
                                        10: "processorId"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        })
    }

    const fetchInvoices = () => {
        return call({
            actions: {
                response: {
                    "Subscription\\Subscription": {
                        custom: {
                            functionName: "getInvoices",
                            get: "invoices",
                            criteria: {}
                        }
                    }
                }
            }
        });
    };

    const fetchUsageSummaries = ({
        subscription,
        subscriptionItem
    }) => {
        return call({
            actions: {
                response: {
                    "Subscription\\Subscription": {
                        custom: {
                            functionName: "getUsageSummaries",
                            get: "result",
                            criteria: {
                                subscription,
                                subscriptionItem,
                            }
                        }
                    }
                }
            }
        })
    }

    // const getPaymentMethod = () => {
    //     return fetchInvoices();
    // };

    const getAvailableProducts = (type = 'package') => {
        return call(
            {},
            `/api/subscription/get-available-products?type=${type}&testMode=${IS_DEV_ENV}`,
            'get'
        );
    }

    const previewProration = ({
        subscription,
        product,
        price,
        qty
    }) => {
        return call({
            actions: {
                response: {
                    "Subscription\\Subscription": {
                        custom: {
                            functionName: "previewProration",
                            get: "result",
                            criteria: {
                                subscription,
                                product,
                                price,
                                qty,
                            }
                        }
                    }
                }
            }
        })
    }

    const updatePackage = ({
        subscription,
        price,
        qty
    }) => {
        return call({
            actions: {
                response: {
                    "Subscription\\Subscription": {
                        custom: {
                            functionName: "updatePackage",
                            get: "result",
                            criteria: {
                                subscription,
                                price,
                                qty,
                            }
                        }
                    }
                }
            }
        });
    }

    const addonSignup = ({
        addon
    }) => {
        return call({
            actions: {
                response: {
                    "Subscription\\Subscription": {
                        custom: {
                            functionName: "addonSignup",
                            get: "result",
                            criteria: {
                                addon: addon.id,
                            }
                        }
                    }
                }
            }
        })
    }

    const toggleSubscriptionItemStatus = ({
        item
    }) => {
        return call({
            actions: {
                update: {
                    "Subscription\\SubscriptionItem": {
                        item: {
                            findBy: {
                                id: item.id
                            },
                            updateRecord: {
                                status: item.status === 'active' ? 'paused' : 'active'
                            }
                        }
                    }
                }
            }
        })
    }

    const refreshToken = ({
        params
    }) => {
        return call(
            params,
            `/api/refreshtoken`,
            'post'
        );
    }

    return {
        INTERVALS: {
            'month': 'monthly',
            'year': 'yearly',
        },
        fetchSeatsInformation,
        fetchSubscriptions,
        fetchInvoices,
        fetchUsageSummaries,
        // getPaymentMethod,
        getAvailableProducts,
        previewProration,
        updatePackage,
        addonSignup,
        toggleSubscriptionItemStatus,
        refreshToken,
        ...factory
    }
}

export const useSeatsInformation =  () => {
    const {fetchSeatsInformation} = useSubscriptionApi();
    const [seatsInformation, setSeatsInformation] = useState({
        activeEmployees: undefined,
        reservedSeats:   undefined,
        flexibleSeats:   undefined,
        availableSeats:  undefined,
        canAddEmployees: undefined,
    });

    async function refresh () {
        return fetchSeatsInformation().then(({
            activeEmployees,
            reservedSeats,
            flexibleSeats
        }) => {
            const refreshed = {
                activeEmployees,
                reservedSeats,
                flexibleSeats,
                availableSeats: flexibleSeats ? Infinity : reservedSeats - activeEmployees,
                canAddEmployees: (activeEmployees < reservedSeats && !flexibleSeats) || flexibleSeats
            };
            setSeatsInformation(refreshed);
            return refreshed;
        });
    }

    useEffect(() => {
        refresh();
    }, []);

    return [seatsInformation, refresh];
}